const CUSTOM_VIEW_FIELDS = {
  ID: {api_name: 'id', required: false, label: 'id', display_label: 'id'},
  USER_ID: {api_name: 'userId', required: true, label: 'User ID', display_label: 'User ID'},
  ORIG_VIEW: {api_name: 'origView', required: true, label: 'Orig View', display_label: 'Orig View'},
  CATEGORY: {api_name: 'category', required: true, label: 'Category', display_label: 'Category'},
  VIEW_NAME: {api_name: 'viewName', required: true, label: 'View Name', display_label: 'View Name'},
  CREATED_BY: {api_name: 'createdBy', required: true, label: 'Created By', display_label: 'Created By'},
  CREATED_AT: {api_name: 'createdAt', required: false, label: 'Created On', display_label: 'Created On'},
  DELETE_VIEW: {api_name: 'deleteView', required: true, label: 'Delete this view', display_label: 'Delete this view'},
}
export {CUSTOM_VIEW_FIELDS};